"use client";
import "../../chunk-MMUBH76A.js";
var AuthLayout = /* @__PURE__ */ ((AuthLayout2) => {
  AuthLayout2["AUTH_FULL"] = "AUTH:FULL";
  AuthLayout2["AUTH_CONDENSED"] = "AUTH:CONDENSED";
  AuthLayout2["EXTERNAL_FULL"] = "EXTERNAL:FULL";
  AuthLayout2["EXTERNAL_CONDENSED"] = "EXTERNAL:CONDENSED";
  return AuthLayout2;
})(AuthLayout || {});
export {
  AuthLayout
};
